import * as React from "react"

 const InHandsEstimator = () => {
  const productionDuration = 3
  const BDGround = 5
  const BDAir = 2
  const BDNDAir = 1
  
  const orderDate = new Date()
  const shipDate = new Date(addBusinessDays(orderDate, productionDuration));
  const inHandsGround = new Date(addBusinessDays(shipDate, BDGround));
  const inHandsAir = new Date(addBusinessDays(shipDate, BDAir));
  const inHandsNextDayAir = new Date(addBusinessDays(shipDate, BDNDAir));

  function addBusinessDays(date, days) {
    date = new Date(+date);
    for (let i=0; i < days; i++) {
      date.setDate(date.getDate() + 1);
      while (!(date.getDay() %6)) {
        date.setDate(date.getDate() + 1);
      }
    }
    return date;
  }

  return(
    <div className="container px-5">
      <h3 className="is-size-4 is-size-5-mobile py-4 has-text-danger is-uppercase has-text-centered">Expected In-Hands Date</h3>
      <p className="block is-size-6">These dates are approximations and do not account for holidays. <b>Delivery dates are not guaranteed due to Covid-related courier delays.</b></p>
      <p className="block is-size-6">Please call <a href="tel:+1-866-944-3824">866-944-3824</a> or email <a href="mailto:sales@etchingexpressions.com">sales@etchingexpressions.com</a> for questions regarding your order or arrival dates.</p>
      <p className="block is-size-6">Production begins one business day after order date, with the exception of holidays. Production time for <b>etched photo/logo bottles</b> begins one business day after artwork is approved.</p>
      <p className="block is-size-6">Current production time:</p>
      <div className="content">
        <ul>
          <li>Small order (1-11 bottles): <b>{productionDuration}</b> business days, then it ships.</li>
          <li>Bulk order (12+ bottles): <b>5-7</b> business days, then it ships.</li>
        </ul>
      </div>
      <p className="block is-size-6">Order online today, <b><span id="order-date">{orderDate.toDateString()}</span></b>, and receive your <span style={{color: "red"}}>small</span> order by:</p>
      <div className="columns m-0 pb-5 has-text-centered">
        <div className="column">
          <h4 className="is-size-5 is-size-6-mobile my-4 has-text-danger is-uppercase">Ground:</h4>
          <p id="in-hands-ground">{inHandsGround.toDateString()}</p>
        </div>
        <div className="column">
          <h4 className="is-size-5 is-size-6-mobile my-4 has-text-danger is-uppercase">2nd Day Air:</h4>
          <p id="in-hands-air">{inHandsAir.toDateString()}</p>
        </div>
        <div className="column">
          <h4 className="is-size-5 is-size-6-mobile my-4 has-text-danger is-uppercase">Next Day Air:</h4>
          <p id="in-hands-next-day-air">{inHandsNextDayAir.toDateString()}</p>
        </div>
      </div>
    </div>
  )
}

export default InHandsEstimator
